import { render, staticRenderFns } from "./GlobalSpinner.vue?vue&type=template&id=630e67d0&scoped=true&"
import script from "./GlobalSpinner.vue?vue&type=script&lang=js&"
export * from "./GlobalSpinner.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSpinner.vue?vue&type=style&index=0&id=630e67d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630e67d0",
  null
  
)

export default component.exports